<template>
  <!-- 未读消息 -->
  <div class="notice">
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"  v-show="list.length > 0">
      <div class="notice-item" v-for="(item,index) in list" @click="stopUrlHref(index)" :key="index">
        <van-popover
          v-model="showPopover[index]"
          trigger="click"
          :actions="actions"
          @select="onSelect"
          placement="bottom-end"
        >
          <template #reference>
            <div>
              <div class="item">
                <div class="item-left">
                  <span class="circle"></span>
                  <span class="name">{{item.title}}</span>
                </div>
                <p class="data">{{item.createdTime}}</p>
              </div>
              <div class="bottom">
                <div class="" v-if="allRead">
                   <van-checkbox v-model="item.checked" icon-size="18px" @click="change"></van-checkbox>
                </div>
                <div>
                  <span v-html="item.content"></span>
                </div>
              </div>
            </div>
          </template>
        </van-popover>

      </div>
    </van-list>

    <noNoticetList v-show="list.length == 0"></noNoticetList>
    <div class="read-bottom" v-if="allRead">
      <div class="read-bottom-1" @click="readSubmit()">
        <van-icon name="success" />
        <p>标记已读</p>
      </div>
      <div class="read-bottom-2" @click="deleteMessage()">
        <van-icon name="delete-o" />
        <p>删除</p>
      </div>
    </div>
  </div>
</template>

<script>
  import noNoticetList from '@/components/noNoticetList'
  import { unnoticeList,readmsg,deleteNotice } from '@/api/notice/notice.js'
  import { getCookie } from '@/utils/cookies'
  export default{
    data() {
      return{
        loading: false,
        finished: false,
        allRead:false,
        allReads:false,
        showPopover: [],
        list:[],
        listQuery:{
          toUser: '',
          pageSize: 10,
          pageNum: 1,
          readed: 0
        },
        index:'',
        // 通过 actions 属性来定义菜单选项
        actions: [{ text: '标记已读' }, { text: '删除' }, { text: '全选' }],
      }
    },
    components: { noNoticetList },
    created() {
      this.listQuery.toUser = getCookie('accountId')
      this.getData();
    },
    methods:{
      change(){
        console.log(this.list);
        this.actions = []
      },
      // 标记为已读
      readSubmit(){
        let params ={
          userId: getCookie('accountId'),
          ids:[]
        }
        let ids = [];
        this.list.forEach(item => {
          if(item.checked){
            ids.push(item.id)
          }
        })
        params.ids = ids.toString()
        this.submit(params);
        this.allRead = false
      },
      // 删除
      deleteMessage(){
        console.log(this.list,'this.list');
        let params ={
          userId: getCookie('accountId'),
          ids:[]
        }
        let ids = [];
        this.list.forEach(item => {
          if(item.checked){
            ids.push(item.id)
          }
        })
        params.ids = ids.toString()
        this.deleted(params);
        this.allRead = false
      },
      deleted(params){
        deleteNotice(params).then(res => {
           console.log(res);
           if(res.data.code== 200){
             this.$toast.success(res.data.data)
             this.list = [];
             this.getData();
           }
        })
      },
      // 标记已读
      submit(params){
        readmsg(params).then(res => {
          console.log(res);
          if(res.data.code== 200){
            this.$toast.success(res.data.data)
            this.list = [];
            this.getData();
          }
        })
      },
      onSelect(action) {
        if(action.text=='全选'){
          this.allRead = true
        }else if(action.text=='标记已读'){
          let index = this.index
          let params ={
            userId: getCookie('accountId'),
            ids: this.list[index].id
          }
          this.submit(params);
        }else if(action.text=='删除'){
          let index = this.index
          let params ={
            userId: getCookie('accountId'),
            ids: this.list[index].id
          }
          this.deleted(params);
        }
      },
      stopUrlHref(index,e){
        console.log(index);
        this.index = index
        // console.log(e);
        // e =e || window.event;
        // if (e.stopPropagation) { //W3C阻止冒泡方法
        //     e.stopPropagation();
        // } else {
        //     e.cancelBubble = true; //IE阻止冒泡方法
        // }
      },
      getData(){
        this.listQuery.pageNum = 0
        this.listQuery.pageSize = 10
        this.finished = false
        this.onLoad()
      },
      // 获取数据
      onLoad () {
         // 调用查询接口
         let self = this
         this.listQuery.pageNum++
         unnoticeList(this.listQuery).then(result => {
            if (result && result.status === 200 && result.data  && result.data.data.list && result.data.data.list.length > 0) {
             self.list = self.list.concat(result.data.data.list)
             self.listQuery.pageNum = result.data.data.pages
             window.setTimeout(() => {
               self.loading = false
               if (self.list.length == result.data.data.total) {
                 self.finished = true
               }
             }, 1000)
           } else {
             self.loading = false
             self.finished = true
           }
         }).catch(() => {
           self.loading = false
           self.listQuery.total = 0
         })
      },
    }
  }
</script>
<style lang="scss">
  .bottom{
     .van-checkbox{
      position: absolute;
      top: 10px;
      left: 9px;
     }
  }
  .notice-item .van-popover__wrapper{
    width: 100%;
  }
</style>
<style lang="scss" scoped>
  .notice{
    background: #EFEFF4;
    position: relative;
    min-height: calc(100vh - 100px);
    .notice-item{
      font-size: 12px;
      margin-bottom: 12px;
      .item{
        background: #FFF;
        display: flex;
        justify-content: space-between;
        padding: 0 16px;
        padding-top: 10px;
        .circle{
          display: inline-block;
          width: 8px;
          height: 8px;
          background: #E52B2B;
          border-radius: 50%;
        }
        .name{
          font-weight: bold;
        }
        .data{
          color: #FF0000;
        }
      }
      .bottom{
        padding: 10px 16px;
        padding-left: 27px;
        background: #fff;
        color: #888888;
        position: relative;
      }
    }
  }
.read-bottom{
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      background: #fff;
      height: 44px;
      display: flex;
      justify-content: center;
      padding-top: 10px;
      .read-bottom-1{
        width: 50%;
        text-align: center;

      }
      .read-bottom-2{
        width: 50%;
        text-align: center;
      }
    }
</style>



// WEBPACK FOOTER //
// src/view/notice/unreadNotice.vue